<template>
  <div class="row">
    <!-- {{activeIndex}} // 
    {{form_data}}-->
    <!-- <pre>{{ form_data }}</pre>
    <pre>{{ broadcastParamSt }}</pre> -->
    <!-- <pre>{{ broadcastParamSt }}</pre> -->
    <div class="col-md-12" v-if="!isEdit">
      <div class="row">
        <div class="col-md-12">
          <label class="col-form-label">
            Sending Speed
            <span class="text text-danger">*</span>
          </label>
          <div class="radio">
            <p class="text-capitalize form-control bg-light">
              {{ broadcastParamSt.speed_mode }}
            </p>
            <p class="alert alert-info"><small>{{ getInfoSpeed(broadcastParamSt.speed_mode) }}</small></p>
            <!-- <label
            :style="'margin-left:10px;'"
            v-for="(row, index) in listSpeedMode"
            :key="index"
            :data-tour-step="'3.' + (index + 1)"
          >
            <input
              :id="row.id"
              type="radio"
              :value="row.id"
              v-model="form_data.speed_mode"
            />
            {{ row.label }}
          </label>
          <a-radio-group size="large" v-model="form_data.speed_mode">
            <a-radio-button
              v-for="(row, index) in listSpeedMode"
              :key="index"
              :value="row.id"
            >
              {{ row.label }}
            </a-radio-button>
          </a-radio-group> -->
          </div>
        </div>
        <template v-if="broadcastParamSt.speed_mode == 'custom'">
          <div class="col-md-12">
            <div class="form-group">
              <label>Delay Interval (Seconds):</label>
              <div class="input-group mb-3">
                <span class="input-group-text">Wait</span>
                <span class="form-control bg-light">{{
                  broadcastParamSt.speed_wait_min
                }}</span>
                <!-- <input
                v-model="form_data.speed_wait_min"
                type="text"
                class="form-control"
                placeholder="Wait Min"
                aria-label="WaitMin"
              /> -->
                <span class="input-group-text">to</span>
                <!-- <input
                v-model="form_data.speed_wait_max"
                type="text"
                class="form-control"
                placeholder="Wait Max"
                aria-label="WaitMax"
              /> -->
                <span class="form-control bg-light">{{
                  broadcastParamSt.speed_wait_max
                }}</span>
                <span class="input-group-text">Seconds</span>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label>Rest Mode:</label>
              <div class="input-group mb-3">
                <span class="form-control bg-light">{{
                  broadcastParamSt.speed_stop_after
                }}</span>
                <!-- <input
                v-model="form_data.speed_stop_after"
                type="text"
                class="form-control"
                placeholder="Stop sending after"
                aria-label="StopAfter"
              /> -->
                <span class="input-group-text">messages</span>
              </div>
              <div class="input-group mb-3">
                <span class="form-control bg-light">{{
                  broadcastParamSt.speed_rest_for
                }}</span>
                <!-- <input
                v-model="form_data.speed_rest_for"
                type="text"
                class="form-control"
                placeholder="and rest for"
                aria-label="RestFor"
              /> -->
                <span class="input-group-text">seconds</span>
              </div>
            </div>
          </div>
        </template>
        <div class="col-md-12">
          <label class="col-form-label">
            Sending Options
            <span class="text text-danger">*</span>
          </label>
          <div class="radio">
            <p class="form-control text-capitalize bg-light">
              {{
                broadcastParamSt.sending_options == "1"
                  ? "Now"
                  : broadcastParamSt.sending_options == "2"
                  ? "Schedule"
                  : "Test"
              }}
            </p>
            <!-- <label
            :style="'margin-left:10px;'"
            v-for="(row, index) in listSendingOptions"
            :key="index"
            :data-tour-step="'3.' + (index + 1)"
          >
            <input
              :id="row.id"
              type="radio"
              :value="row.id"
              v-model="form_data.sending_options"
            />
            {{ row.label }}
          </label>
          <a-radio-group size="large" v-model="form_data.sending_options">
            <a-radio-button
              v-for="(row, index) in listSendingOptions"
              :key="index"
              :value="row.id"
            >
              {{ row.label }}
            </a-radio-button>
          </a-radio-group> -->
          </div>
        </div>
        <div class="col-md-12" v-if="broadcastParamSt.sending_options == '2'">
          <div class="form-group">
            <label>Time to send:</label>
            <div class="form-control bg-light">
              <!-- <datetime
              :min-datetime="currentDateTimeUTC()"
              :zone="'local'"
              :use12-hour="true"
              input-class="form-control"
              value-zone="UTC"
              type="datetime"
              v-model="form_data.sending_schedule"
            ></datetime> -->
              {{
                $moment(broadcastParamSt.sending_schedule).format(
                  "YYYY-MM-DD HH:mm:ss"
                )
              }}
              <!-- <input type="text" class="form-control floating datetimepicker" /> -->
            </div>
            <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                >UTC: {{broadcastParam.sending_schedule}}</span>-->
          </div>
        </div>
        <div class="row" v-if="broadcastParamSt.sending_options == '3'">
          <div class="col-md-12">
            <div class="form-group">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group m-b-30">
                    <input
                      type="text"
                      placeholder="Phone number to test"
                      class="form-control"
                      v-model="form_data.to_test_text"
                    />
                    <div class="input-group-append">
                      <button
                        @click="bcMessageHandlerTest"
                        class="btn btn-warning"
                        type="button"
                      >
                        <i class="fa fa-send"></i>
                      </button>
                    </div>
                    <small class="text-muted"
                      >Type phone number and separate with comma for many test
                      destination.</small
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label data-tour-step="3.4">Recurring:</label>
            <div class="checkbox">
              <!-- <input
      
              v-model="isRecurring"
              :key="1"
              type="checkbox"
              name="checkbox"
            /> -->
              <!-- <a-checkbox v-model="isRecurring"></a-checkbox> -->
              <span
                :class="`badge badge-${
                  broadcastParamSt.is_recurring == 1 ? 'primary' : 'secondary'
                }`"
              >
                {{ broadcastParamSt.is_recurring == 1 ? "Yes" : "No" }}
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="broadcastParamSt.is_recurring == 1">
          <div class="form-group">
            <label>Frequency</label>
            <!-- <select v-model="form_data.recurring_form.recurrence" class="form-control">
            <option>-- Select --</option>
            <option
              v-for="(item, index) in recurrenceOptions"
              :key="item + index"
              :label="item"
              :value="item"
            >
              {{ item | capitalising }}
            </option>
          </select> -->
            <div class="">
              <p class="form-control text-capitalize bg-light">
                {{ broadcastParamSt.recurring_form.recurrence }}
              </p>
              <!-- <a-radio-group size="large" :disabled="true" v-model="broadcastParamSt.recurring_form.recurrence">
              <a-radio-button
                v-for="(item, index) in recurrenceOptions"
                :key="index"
                :value="item"
              >
              {{ item | capitalising }}
              </a-radio-button>
            </a-radio-group> -->
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12" v-if="broadcastParamSt.is_recurring == 1">
              <div class="form-group">
                <label>Set Time (HH:MM)</label>
                <br />
                <!-- {{start_hour}} -->
                <!-- <select style="width: 50px" v-model="start_hour">
                <option :value="''">-- Select --</option>
                <option :value="'00'">00</option>
                <option
                  v-for="hour in 23"
                  :key="hour"
                  :value="hour < 10 ? '0' + hour : hour"
                >
                  {{ hour < 10 ? "0" + hour : hour }}
                </option>
              </select>
              <select style="width: 50px" v-model="start_minute">
                <option :value="''">-- Select --</option>
                <option :value="'00'">00</option>
                <option
                  v-for="minute in 59"
                  :key="minute"
                  :value="minute < 10 ? '0' + minute : minute"
                >
                  {{ minute < 10 ? "0" + minute : minute }}
                </option>
              </select> -->
                <!-- <a-date-picker format="HH:mm" type="time" v-model="form_data.recurring_form.recurrence_time">
                <a-icon slot="suffixIcon" type="clock-circle" />
              </a-date-picker> -->
                <p class="form-control bg-light">
                  {{ broadcastParamSt.recurring_form.recurrence_time }}
                </p>
                <!-- <datetime
                input-class="form-control"
                type="time"
                v-model="form_data.recurring_form.recurrence_time"
              ></datetime> -->
                <div classs="text-muted" style="font-size: 11px">
                  Timezone in GMT+7 (Jakarta Time / WIB)
                </div>
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="
                broadcastParamSt.recurring_form.recurrence != 'daily' &&
                broadcastParamSt.is_recurring == 1
              "
            >
              <div
                class="form-group"
                v-if="broadcastParamSt.recurring_form.recurrence == 'weekly'"
              >
                <label>Every</label>
                <p class="form-control bg-light">
                  {{ broadcastParamSt.recurring_form.recurrence_every }}
                </p>
                <!-- <select v-model="broadcastParamSt.recurring_form.recurrence_every" class="form-control">
                <option>-- Select Day --</option>
                <option
                  v-for="(item, index) in weeklyOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select> -->
              </div>
              <div
                class="form-group"
                v-if="broadcastParamSt.recurring_form.recurrence != 'weekly'"
              >
                <label>Every</label>
                <p class="form-control bg-light">
                  {{ broadcastParamSt.recurring_form.recurrence_every }}
                </p>
                <!-- <select v-model="broadcastParamSt.recurring_form.recurrence_every" class="form-control">
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in monthlyOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select> -->
              </div>
            </div>
            <div
              class="col-md-12"
              v-if="
                broadcastParamSt.recurring_form.recurrence != 'daily' &&
                broadcastParamSt.recurring_form.recurrence != 'weekly' &&
                broadcastParamSt.is_recurring == 1
              "
            >
              <div
                class="form-group"
                v-if="form_data.recurring_form.recurrence == 'annually'"
              >
                <label>Select Month</label>
                <p class="form-control bg-light">
                  {{
                    broadcastParamSt.recurring_form.recurrence_annually_month
                  }}
                </p>
                <!-- <select
                v-model="form_data.recurring_form.recurrence_annually_month"
                class="form-control"
              >
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in annuallyMonthOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select>
              --></div>
            </div>
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="
            broadcastParamSt.is_recurring == 1 &&
            broadcastParamSt.recurring_form.recurrence_end != 'never'
          "
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>End Date</label>
                <!-- <p class="form-control text-capitalize bg-light">{{broadcastParamSt.recurring_form.recurrence_end}}</p> -->

                <p class="form-control bg-light">
                  {{ broadcastParamSt.recurring_form.recurrence_end_date }}
                </p>
                <!-- <select v-model="broadcastParamSt.recurring_form.recurrence_end" class="form-control">
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in recurrenceEndOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="col-md-12">
        <label class="col-form-label">
          Sending Speed
          <span class="text text-danger">*</span>
        </label>
        <div class="radio">
          <!-- <label
            :style="'margin-left:10px;'"
            v-for="(row, index) in listSpeedMode"
            :key="index"
            :data-tour-step="'3.' + (index + 1)"
          >
            <input
              :id="row.id"
              type="radio"
              :value="row.id"
              v-model="form_data.speed_mode"
            />
            {{ row.label }}
          </label> -->

          <a-radio-group size="large" v-model="form_data.speed_mode">
            <template v-for="(row, index) in listSpeedMode">
              <template>
                <!-- <a-popover placement="bottom" :key="index" :title="row.label">
                  <template slot="content">
                     <p style="max-width: 250px;">{{ getInfoSpeed(row.id) }}</p>
                  </template>
                  <a-radio-button :value="row.id">
                    {{ row.label }}
                  </a-radio-button>
                </a-popover> -->
                <a-tooltip placement="top" :key="index" :title="getInfoSpeed(row.id)">
                  <template slot="title">
                    <span>{{ getInfoSpeed(row.id) }}</span>
                  </template>
                  <a-radio-button :value="row.id">
                    {{ row.label }}
                  </a-radio-button>
                </a-tooltip>
              </template>
            </template>
          </a-radio-group>
        </div>
      </div>
      <template v-if="form_data.speed_mode == 'custom'">
        <div class="col-md-12">
          <div class="form-group">
            <label>Delay Interval (Seconds):</label>
            <div class="input-group mb-3">
              <span class="input-group-text">Wait</span>
              <input
                v-model="form_data.speed_wait_min"
                type="text"
                class="form-control"
                placeholder="Wait Min"
                aria-label="WaitMin"
              />
              <span class="input-group-text">to</span>
              <input
                v-model="form_data.speed_wait_max"
                type="text"
                class="form-control"
                placeholder="Wait Max"
                aria-label="WaitMax"
              />
              <span class="input-group-text">Seconds</span>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>Rest Mode:</label>
            <div class="input-group mb-3">
              <input
                v-model="form_data.speed_stop_after"
                type="text"
                class="form-control"
                placeholder="Stop sending after"
                aria-label="StopAfter"
              />
              <span class="input-group-text">messages</span>
            </div>
            <div class="input-group mb-3">
              <input
                v-model="form_data.speed_rest_for"
                type="text"
                class="form-control"
                placeholder="and rest for"
                aria-label="RestFor"
              />
              <span class="input-group-text">seconds</span>
            </div>
          </div>
        </div>
      </template>
      <div class="col-md-12">
        <label class="col-form-label">
          Sending Options
          <span class="text text-danger">*</span>
        </label>
        <div class="radio">
          <!-- <label
            :style="'margin-left:10px;'"
            v-for="(row, index) in listSendingOptions"
            :key="index"
            :data-tour-step="'3.' + (index + 1)"
          >
            <input
              :id="row.id"
              type="radio"
              :value="row.id"
              v-model="form_data.sending_options"
            />
            {{ row.label }}
          </label> -->
          <a-radio-group size="large" v-model="form_data.sending_options">
            <a-radio-button
              v-for="(row, index) in listSendingOptions"
              :key="index"
              :value="row.id"
            >
              {{ row.label }}
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="col-md-12" v-if="form_data.sending_options == '2'">
        <div class="form-group">
          <label>Time to send:</label>
          <div class="cal-icon">
            <datetime
              :min-datetime="currentDateTimeUTC()"
              :zone="'local'"
              :use12-hour="true"
              input-class="form-control"
              value-zone="UTC"
              type="datetime"
              v-model="form_data.sending_schedule"
            ></datetime>
            <!-- <input type="text" class="form-control floating datetimepicker" /> -->
          </div>
          <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                >UTC: {{broadcastParam.sending_schedule}}</span>-->
        </div>
      </div>
      <div class="row" v-if="form_data.sending_options == '3'">
        <div class="col-md-12">
          <div class="form-group">
            <div class="row">
              <div class="col-md-12">
                <div class="input-group m-b-30">
                  <input
                    type="text"
                    placeholder="Phone number to test"
                    class="form-control"
                    v-model="form_data.to_test_text"
                  />
                  <div class="input-group-append">
                    <button
                      @click="bcMessageHandlerTest"
                      class="btn btn-warning"
                      type="button"
                    >
                      <i class="fa fa-send"></i>
                    </button>
                  </div>
                  <small class="text-muted"
                    >Type phone number and separate with comma for many test
                    destination.</small
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label data-tour-step="3.4">Recurring:</label>
          <div class="checkbox">
            <!-- <input
      
              v-model="isRecurring"
              :key="1"
              type="checkbox"
              name="checkbox"
            /> -->
            <a-checkbox v-model="isRecurring"></a-checkbox>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="isRecurring">
        <div class="form-group">
          <label>Frequency</label>
          <!-- <select v-model="form_data.recurring_form.recurrence" class="form-control">
            <option>-- Select --</option>
            <option
              v-for="(item, index) in recurrenceOptions"
              :key="item + index"
              :label="item"
              :value="item"
            >
              {{ item | capitalising }}
            </option>
          </select> -->
          <div class="">
            <a-radio-group
              size="large"
              v-model="form_data.recurring_form.recurrence"
            >
              <a-radio-button
                v-for="(item, index) in recurrenceOptions"
                :key="index"
                :value="item"
              >
                {{ item | capitalising }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12" v-if="isRecurring">
            <div class="form-group">
              <label>Set Time (HH:MM)</label>
              <br />
              <!-- {{start_hour}} -->
              <!-- <select style="width: 50px" v-model="start_hour">
                <option :value="''">-- Select --</option>
                <option :value="'00'">00</option>
                <option
                  v-for="hour in 23"
                  :key="hour"
                  :value="hour < 10 ? '0' + hour : hour"
                >
                  {{ hour < 10 ? "0" + hour : hour }}
                </option>
              </select>
              <select style="width: 50px" v-model="start_minute">
                <option :value="''">-- Select --</option>
                <option :value="'00'">00</option>
                <option
                  v-for="minute in 59"
                  :key="minute"
                  :value="minute < 10 ? '0' + minute : minute"
                >
                  {{ minute < 10 ? "0" + minute : minute }}
                </option>
              </select> -->
              <!-- <a-date-picker format="HH:mm" type="time" v-model="form_data.recurring_form.recurrence_time">
                <a-icon slot="suffixIcon" type="clock-circle" />
              </a-date-picker> -->
              <!-- <datetime
                input-class="form-control"
                type="time"
                v-model="form_data.recurring_form.recurrence_time"
              ></datetime> -->
              <a-time-picker
                size="large"
                v-model="form_data.recurring_form.recurrence_time"
                valueFormat="HH:mm"
                format="HH:mm"
              />

              <div classs="text-muted" style="font-size: 11px">
                Timezone in GMT+7 (Jakarta Time / WIB)
              </div>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="form_data.recurring_form.recurrence != 'daily' && isRecurring"
          >
            <div
              class="form-group"
              v-if="form_data.recurring_form.recurrence == 'weekly'"
            >
              <label>Every</label>
              <select
                v-model="form_data.recurring_form.recurrence_every"
                class="form-control"
              >
                <option>-- Select Day --</option>
                <option
                  v-for="(item, index) in weeklyOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select>
            </div>
            <div
              class="form-group"
              v-if="form_data.recurring_form.recurrence != 'weekly'"
            >
              <label>Every</label>
              <select
                v-model="form_data.recurring_form.recurrence_every"
                class="form-control"
              >
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in monthlyOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="
              form_data.recurring_form.recurrence != 'daily' &&
              form_data.recurring_form.recurrence != 'weekly' &&
              isRecurring
            "
          >
            <div
              class="form-group"
              v-if="form_data.recurring_form.recurrence == 'annually'"
            >
              <label>Select Month</label>
              <select
                v-model="form_data.recurring_form.recurrence_annually_month"
                class="form-control"
              >
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in annuallyMonthOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12" v-if="isRecurring">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>End Date</label>
              <select
                v-model="form_data.recurring_form.recurrence_end"
                class="form-control"
              >
                <option>-- Select --</option>
                <option
                  v-for="(item, index) in recurrenceEndOptions"
                  :key="item + index"
                  :label="item"
                  :value="item"
                >
                  {{ item | capitalising }}
                </option>
              </select>
            </div>
          </div>
          <div
            class="col-md-12"
            v-if="form_data.recurring_form.recurrence_end != 'never'"
          >
            <div class="form-group">
              <label>Select Date</label>
              <!-- <input
                class="form-control datetimepicker"
                v-model="form_data.recurring_form.recurrence_end_date"
                type="date"
              />
              {{ form_data.recurring_form.recurrence_end_date }} -->
              <div class="">
                <a-date-picker
                  format="YYYY-MM-DD"
                  size="large"
                  class="w-100"
                  valueFormat="YYYY-MM-DD"
                  v-model="form_data.recurring_form.recurrence_end_date"
                />
              </div>
              <!-- <datetime
                :min-datetime="currentDateTimeUTC()"
                :zone="'local'"
                input-class="form-control"
                value-zone="UTC"
                type="date"
                v-model="form_data.recurring_form.recurrence_end_date"
              ></datetime>-->
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-outline-primary w-50"
            @click="editRecurring"
            v-if="!isEdit"
          >
            Edit Scheduler
          </button>
          <div class="d-flex">
            <button
              class="btn btn-primary w-50 mr-3"
              @click="updateRecurring"
              v-if="isEdit"
            >
              Save Scheduler
            </button>
            <button
              class="btn btn-outline-danger w-50"
              @click="cancelRecurring"
              v-if="isEdit"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currentDateTimeUTC, convertTzDatetimeToDateISO } from "@/utils/helper";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  components: {
    Datetime,
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      start_hour: "00",
      start_minute: "01",
      getContentOptions: {},
      loading: false,
      isRecurring: false,
      recurrenceOptions: ["daily", "weekly", "monthly", "annually"],
      weeklyOptions: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ],
      monthlyOptions: [
        "first",
        "last",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      annuallyMonthOptions: [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ],
      recurrenceEndOptions: ["never", "custom"],
      sendingSchedule: "",
      form_data: {
        is_recurring: 0,
        recurring_form: {
          recurrence: "daily",
          recurrence_time: "",
          recurrence_every: "",
          recurrence_annually_month: "",
          recurrence_end: "never",
          recurrence_end_date: "",
        },
        speed_mode: "safe",
        speed_wait_min: "0",
        speed_wait_max: "0",
        speed_stop_after: "0",
        speed_rest_for: "0",
        sending_options: 1,
        sending_schedule: "",
        to_test: "",
        to_test_text: "",
      },
      isEdit: false,
      listSendingOptions: [
        { id: 1, label: "Now" },
        { id: 2, label: "Schedule" },
        //,
        //{ id: 3, label: "Send a test" }
      ],
      listSpeedMode: [
        { id: "safe", label: "Safe" },
        { id: "normal", label: "Normal" },
        { id: "fast", label: "Fast" },
        { id: "custom", label: "Custom" },
      ],
    };
  },
  computed: {
    infoSpeed() {
      return this.$store.state.omniwa.infoSpeed;
    },
    isCompleteForm() {
      const { title, license_id, is_group, to_group, to, message } =
        this.broadcastParamSt;
      if (!title) return false;
      if (!license_id) return false;
      if (is_group) {
        if (!to_group.length) return false;
      } else {
        if (!to.length) return false;
      }
      if (!message.text) return false;
      return true;
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    detailBroadcast() {
      return this.$store.state.omniwa.detailBroadcast;
    },
    isShowBroadcast() {
      return 0;
    },
  },
  filters: {
    getVal: function (data) {
      let c;
    },
    capitalising: function (data) {
      var capitalized = [];
      data.split(" ").forEach((word) => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    },
  },
  created() {},
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
  },
  watch: {
    isEdit(val) {
      this.$emit("updateEdit", val);
    },
    // isCompleteForm: {
    //   handler(val) {
    //     if (val) {
    //       this.form_data = {
    //         is_recurring: 0,
    //         recurring_form: {
    //           recurrence: "daily",
    //           recurrence_time: "00:00",
    //           recurrence_every: "",
    //           recurrence_annually_month: "",
    //           recurrence_end: "never",
    //           recurrence_end_date: "",
    //         },
    //         speed_mode: "normal",
    //         speed_wait_min: "0",
    //         speed_wait_max: "0",
    //         speed_stop_after: "0",
    //         speed_rest_for: "0",
    //         sending_options: 1,
    //         sending_schedule: "",
    //       };
    //       this.start_hour = "00";
    //       this.start_minute = "00";
    //       this.form_data.recurring_form.recurrence_time = this.start_hour + ":" + this.start_minute;
    //     }
    //   },
    //   deep: true,
    // },
    // broadcastStep: {
    //   handler: function (val, oldVal) {
    //     if (val == '') {
    //       let bc = structuredClone(this.broadcastParamSt);
    //       this.form_data = {
    //         is_recurring: bc.is_recurring,
    //         recurring_form: {
    //           recurrence: bc.recurring_form.recurrence,
    //           recurrence_time: bc.recurring_form.recurrence_time,
    //           recurrence_every: bc.recurring_form.recurrence_every,
    //           recurrence_annually_month: bc.recurring_form.recurrence_annually_month,
    //           recurrence_end: bc.recurring_form.recurrence_end,
    //           recurrence_end_date: bc.recurring_form.recurrence_end_date,
    //         },
    //       };
    //     }
    //   },
    // },
    // broadcastParamSt: {
    //   handler: async function (val, oldVal) {
    //     if (val != oldVal) {
    //       // console.log("oldValForm3", oldVal);
    //       // console.log("newValForm3", val);
    //       if (val.is_recurring == 1) {
    //         let splitHour = val.recurring_form.recurrence_time.split(":");
    //         this.start_hour = splitHour[0];
    //         this.start_minute = splitHour[1];
    //         this.isRecurring = true;
    //         this.form_data = val.recurring_form;
    //         // this.formData.recurrence = val.recurrence;
    //         // this.formData.recurrence_time = val.recurrence_time;
    //         // this.formData.recurrence_every = val.recurrence_every;
    //         // this.formData.recurrence_annually_month =
    //         //   val.recurrence_annually_month;
    //         // this.formData.recurrence_end = val.recurrence_end;
    //         // this.formData.recurrence_end_date = val.recurrence_end_date;
    //       }
    //     }
    //   },
    //   deep: true,
    // },
    // activeIndex: {
    //   handler: function (val, oldVal) {
    //     // console.log("val", val, "oldVal", oldVal);
    //     if (val == 2) {
    //       var that = this;
    //       setTimeout(function () {
    //         that.updateRecurring();
    //       }, 200);
    //     }
    //   },
    //   deep: true,
    // },
  },
  methods: {
    getInfoSpeed(data) {
      if (this.infoSpeed !== null) {
        if(data == 'custom'){
          return 'Pesan akan terkirim berdasarkan interval dan delay yang diatur.'
        }
        return this.infoSpeed[data];
      }
      return "";
    },
    convertTzDatetimeToDateISO(utcdatetime) {
      return convertTzDatetimeToDateISO(utcdatetime);
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    },
    editRecurring() {
      this.form_data = {
        is_recurring: this.broadcastParamSt.is_recurring,
        recurring_form: {
          recurrence: this.broadcastParamSt.recurring_form.recurrence,
          recurrence_time: this.broadcastParamSt.recurring_form.recurrence_time,
          recurrence_every:
            this.broadcastParamSt.recurring_form.recurrence_every,
          recurrence_annually_month:
            this.broadcastParamSt.recurring_form.recurrence_annually_month,
          recurrence_end: this.broadcastParamSt.recurring_form.recurrence_end,
          recurrence_end_date:
            this.broadcastParamSt.recurring_form.recurrence_end_date,
        },
        speed_mode: this.broadcastParamSt.speed_mode,
        speed_wait_min: this.broadcastParamSt.speed_wait_min,
        speed_wait_max: this.broadcastParamSt.speed_wait_max,
        speed_stop_after: this.broadcastParamSt.speed_stop_after,
        speed_rest_for: this.broadcastParamSt.speed_rest_for,
        sending_options: this.broadcastParamSt.sending_options,
        sending_schedule: this.broadcastParamSt.sending_schedule,
        to_test: this.broadcastParamSt.to_test,
        to_test_text: this.broadcastParamSt.to_test_text,
      };
      if (this.broadcastParamSt.is_recurring == 1) {
        this.isRecurring = true;
      } else {
        this.isRecurring = false;
      }
      this.isEdit = true;
    },
    cancelRecurring() {
      this.isEdit = false;
    },
    updateRecurring() {
      // let dataParam = {
      //   mp_product_master_id: "",
      //   keywords_id: [],
      //   min_price: 0,
      //   max_price: 0,
      //   sort_by: "price",
      //   order_by: "asc",
      //   mp_id: [],
      //   sending_options: 1,
      //   is_publish: 1,
      //   is_recurring: 0,
      //   recurring_form: {
      //     recurrence: "",
      //     recurrence_time: "00:01",
      //     recurrence_every: "",
      //     recurrence_annually_month: "",
      //     recurrence_end: "never",
      //     recurrence_end_date: ""
      //   }
      // };
      // let dataParam = structuredClone(this.broadcastParamSt);
      console.log(this.form_data);
      this.broadcastParamSt = {
        ...this.broadcastParamSt,
        is_recurring: this.isRecurring ? 1 : 0,
        recurring_form: structuredClone(this.form_data.recurring_form),
        sending_options: this.form_data.sending_options,
        sending_schedule: this.form_data.sending_schedule,
        speed_mode: this.form_data.speed_mode,
        speed_rest_for: this.form_data.speed_rest_for,
        speed_stop_after: this.form_data.speed_stop_after,
        speed_wait_max: this.form_data.speed_wait_max,
        speed_wait_min: this.form_data.speed_wait_min,
        to_test: this.form_data.to_test,
        to_test_text: this.form_data.to_test_text,
      };
      if (this.form_data.speed_mode !== "custom") {
        this.broadcastParamSt.speed_rest_for = "";
        this.broadcastParamSt.speed_stop_after = "";
        this.broadcastParamSt.speed_wait_max = "";
        this.broadcastParamSt.speed_wait_min = "";
      }
      if (this.form_data.sending_options == 1) {
        this.broadcastParamSt.sending_schedule = "";
      }
      if (!this.isRecurring) {
        this.broadcastParamSt.recurring_form = {
          recurrence: "daily",
          recurrence_time: "00:01",
          recurrence_every: "",
          recurrence_annually_month: "",
          recurrence_end: "never",
          recurrence_end_date: "",
        };
      }
      if (this.form_data.recurring_form.recurrence_end == "never") {
        this.broadcastParamSt.recurring_form.recurrence_end_date = "";
      }
      console.log("update", this.broadcastParamSt);
      this.isEdit = false;
      // let form1 = this.form_dataScrapeSt;
      // dataParam.mp_product_master_id = form1.mp_product_master_id;
      // dataParam.keywords_id = form1.keywords_id;
      // dataParam.min_price = parseInt(form1.min_price);
      // dataParam.max_price = parseInt(form1.max_price);
      // dataParam.sort_by = form1.sort_by;
      // dataParam.order_by = form1.order_by;
      // dataParam.mp_id = form1.mp_id;
      // dataParam.sending_options = form1.sending_options;
      // dataParam.sending_schedule = this.sendingSchedule;
      // dataParam.is_recurring = this.isRecurring;

      // let dataParam = this.form_dataScrapeSt;
      // let dataParam = this.form_dataScrapeSt;
      // if (this.isRecurring == true) {
      //   dataParam.is_recurring = 1;
      // } else {
      //   dataParam.is_recurring = 0;
      // }
      // dataParam.recurring_form = this.form_data;
      // dataParam.recurring_form.recurrence_time =
      //   this.start_hour + ":" + this.start_minute;

      // let to_test = this.form_data.to_test;
      // let to_test_text = this.form_data.to_test_text;
      // dataParam.to_test = to_test;
      // dataParam.to_test_text = to_test_text;
      // dataParam.is_publish = 1;
      // dataParam.speed_mode = this.form_data.speed_mode;
      // dataParam.speed_wait_min = this.form_data.speed_wait_min;
      // dataParam.speed_wait_max = this.form_data.speed_wait_max;
      // dataParam.speed_rest_for = this.form_data.speed_rest_for;
      // dataParam.speed_stop_after = this.form_data.speed_stop_after;

      // dataParam.sending_options = this.form_data.sending_options;
      // dataParam.sending_schedule = this.sendingSchedule;

      // console.log("dataParam", dataParam);
      // this.$store.dispatch("omniwa/actBroadcastParamSt", dataParam);
      // console.log("param", this.broadcastParamSt);

      // this.$store.dispatch("omniwa/actBroadcastParamSt", dataParam);
      // this.$store.dispatch("instagramSchedule/actform_dataScrapeSt", dataParam);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/scheduler.vue